
export default {
  "VideoCard.VideoCardWrapper": (
    { videoCard },
    outlet
  ) => {
    outlet({ video: videoCard });
  },
};
